import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-pptx-story-modal',
  templateUrl: './pptx-story-modal.component.html',
  styleUrls: ['./pptx-story-modal.component.scss']
})
export class PptxStoryModalComponent implements OnInit, OnChanges {

  @Input() story;
  @Output() saveStory: EventEmitter<any> = new EventEmitter<any>();
  @Output() startGeneratePresentation: EventEmitter<any> = new EventEmitter<any>();

  public Yiit = Yiit;
  public modalMessage = window['PPTX_STORY_MSG'] || '';
  public isPPTXDisabled = true;

  constructor(private httpClient: HttpClient, private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.isPPTXDisabled = (this.story) ? !this.story.pptx : false;
    this.cd.detectChanges();
  }

  ngOnChanges(): void {
    this.isPPTXDisabled = (this.story) ? !this.story.pptx : false;
    this.cd.detectChanges();
  }

  generatePresentation(){
    this.startGeneratePresentation.emit(true);
  }

  uploadPptx(event){
    let self = this;
    let file = event.target.files[0];
    let reader = new FileReader();
    reader.onloadend = function() {
      let result = reader.result;
      self.httpClient.post('/story/save-pptx', {
        event_id: window['EVENT_ID'],
        story_id: self.story.id,
        data: result
      }).subscribe((result) => { self.isPPTXDisabled = false; self.cd.detectChanges(); self.saveStory.emit(true)});
    };
    reader.readAsDataURL(file);
  }

}
